import { render } from "./NewsTrend.vue?vue&type=template&id=5484b5f1"
import script from "./NewsTrend.vue?vue&type=script&lang=js"
export * from "./NewsTrend.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dongjoosong/Code/dp7stage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__